// extracted by mini-css-extract-plugin
export default {"confirmSection":"SystemErrorMessage_confirmSection__XywLY","errorIcon":"SystemErrorMessage_errorIcon__rilbm","confirmBold":"SystemErrorMessage_confirmBold__MOeBv"};